import type { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faShippingFast as farShippingFast,
  faGift as farGift,
  faUserCircle as farUserCircle,
  faBell as farBell,
  faGraduationCap as farGraduationCap,
  faCamera as farCamera,
  faStar as farStar,
  faCalendar as farCalendar,
  faCloudDownload as farCloudDownload,
  faUserPlus as farUserPlus,
  faEye as farEye,
  faEyeSlash as farEyeSlash,
  faTrash as farTrash,
  faTrashCan as farTrashCan,
  faTruck as farTruck,
  faSchool as farSchool,
  faHourglassStart as farHourglassStart,
  faEnvelope as farEnvelope,
  faHome as farHome,
  faMobileAlt as farMobileAlt,
  faEdit as farEdit,
  faBookHeart as farBookHeart,
  faBadgeDollar as farBadgeDollar,
  faTriangleExclamation as farTriangleExclamation,
  faLock as farLock
} from '@fortawesome/pro-regular-svg-icons';
import {
  faUser as fasUser,
  faUserGraduate as fasUserGraduate,
  faGift as fasGift,
  faTrash as fasTrash
} from '@fortawesome/pro-solid-svg-icons';
import {
  faChevronRight as fassChevronRight,
  faChevronLeft as fassChevronLeft,
  faChevronDown as fassChevronDown,
  faChevronUp as fassChevronUp,
  faTimes as fassTimes,
  faCheck as fassCheck,
  faArrowUp as fassArrowUp,
  faLongArrowLeft as fassLongArrowLeft,
  faLongArrowRight as fassLongArrowRight,
  faArrowLeft as fassArrowLeft,
  faArrowRight as fassArrowRight,
  faPlus as fassPlus,
  faMinus as fassMinus,
  faSearch as fassSearch,
  faCheckCircle as fassCheckCircle
} from '@fortawesome/sharp-solid-svg-icons';
import {
  faCheckCircle as fasrCheckCircle,
  faTimesCircle as fasrTimesCircle,
  faQuestionCircle as fasrQuestionCircle,
  faInfoCircle as fasrInfoCircle,
  faShoppingCart as fasrShoppingCart,
  faCircleExclamation as fasrCircleExclamation,
  faPlusCircle as fasrPlusCircle,
  faTimes as fasrTimes
} from '@fortawesome/sharp-regular-svg-icons';

const ICONS = [
  // Pro Regular
  farShippingFast,
  farGift,
  farUserCircle,
  farBell,
  farGraduationCap,
  farCamera,
  farStar,
  farCalendar,
  farCloudDownload,
  farUserPlus,
  farEye,
  farEyeSlash,
  farTrash,
  farTrashCan,
  farTruck,
  farSchool,
  farHourglassStart,
  farEnvelope,
  farHome,
  farMobileAlt,
  farEdit,
  farBookHeart,
  farBadgeDollar,
  farTriangleExclamation,
  farLock,
  // Pro Solid
  fasUser,
  fasUserGraduate,
  fasGift,
  fasTrash,
  // Sharp Solid
  fassChevronRight,
  fassChevronLeft,
  fassChevronDown,
  fassChevronUp,
  fassTimes,
  fassCheck,
  fassArrowUp,
  fassLongArrowLeft,
  fassLongArrowRight,
  fassArrowLeft,
  fassArrowRight,
  fassPlus,
  fassMinus,
  fassSearch,
  fassCheckCircle,
  // Sharp Regular
  fasrCheckCircle,
  fasrTimesCircle,
  fasrQuestionCircle,
  fasrInfoCircle,
  fasrShoppingCart,
  fasrCircleExclamation,
  fasrPlusCircle,
  fasrTimes
];

export function registerLtIcons(library: FaIconLibrary): void {
  library.addIcons(...ICONS);
}
